
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { FaWhatsapp, FaInstagram, FaYoutube } from "react-icons/fa";

export function ContactCards() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511998874081', '_blank');
  };

  const contacts = [
    {
      icon: FaWhatsapp,
      title: "WhatsApp",
      description: "Entre em contato direto pelo WhatsApp para agendamentos e dúvidas",
      cta: "+55 11 99887-4081",
      iconBg: "bg-green-50",
      iconColor: "text-green-600",
      onClick: handleWhatsAppClick,
      variant: "default" as const,
    },
    {
      icon: Mail,
      title: "E-mail",
      description: "Envie suas dúvidas ou solicite informações por e-mail",
      cta: "Enviar E-mail",
      iconBg: "bg-brand-primary/10",
      iconColor: "text-brand-primary",
      onClick: () => window.open('mailto:brenda.ramos.nutri@gmail.com'),
      variant: "outline" as const,
    },
    {
      icon: FaInstagram,
      title: "Instagram",
      description: "Acompanhe dicas diárias e conteúdo exclusivo no Instagram",
      cta: "Seguir",
      iconBg: "bg-pink-50",
      iconColor: "text-pink-500",
      onClick: () => window.open('https://www.instagram.com/brenda.nutricionista/', '_blank'),
      variant: "outline" as const,
    },
    {
      icon: FaYoutube,
      title: "YouTube",
      description: "Assista vídeos educativos sobre nutrição e saúde",
      cta: "Inscrever-se",
      iconBg: "bg-red-50",
      iconColor: "text-red-500",
      onClick: () => window.open('#', '_blank'),
      variant: "outline" as const,
    },
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-6 mb-16">
          {contacts.map((contact, i) => (
            <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-all duration-300 p-6 text-center flex flex-col">
              <div className={`w-14 h-14 ${contact.iconBg} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                <contact.icon className={`w-7 h-7 ${contact.iconColor}`} />
              </div>
              <h3 className="text-base font-bold mb-2 text-gray-800 font-accent">{contact.title}</h3>
              <p className="text-gray-500 text-sm font-text mb-4 flex-1 leading-relaxed">
                {contact.description}
              </p>
              <Button
                variant={contact.variant}
                className={contact.variant === "default"
                  ? "bg-brand-primary hover:bg-brand-primary/90 font-semibold text-sm"
                  : "border-brand-primary text-brand-primary hover:bg-brand-primary/5 font-semibold text-sm"
                }
                onClick={contact.onClick}
              >
                {contact.cta}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
